import './App.css';
import { Routes, Route } from "react-router";
import Layout from "./components/Layout/Index";
import Home from './components/Home/Index';
import About from './components/About/Index';
import Contact from './components/Contact/Index';
import Product from './components/Product/Index';
import Service from './components/Service/Index';
import Team from './components/Team/Index';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <>
    <Routes>
    <Route element={<Layout/>}>
      <Route exact path= "/" element={ <Home /> } />
      <Route exact path= "/about" element={ <About /> } />
      <Route exact path= "/contact" element={ <Contact /> } />
      <Route exact path= "/product" element={ <Product /> } />
      <Route exact path= "/service" element={ <Service /> } />
      <Route exact path= "/team" element={ <Team /> } />
      </Route>
    </Routes>
    </>

  );
}

export default App;

